import { ENV } from "../Utils";
import { apiFetch } from "../Utils/apiFetch";

export class AssistanceApi {
  baseApi = ENV.BASE_API;

  async createAssistance(accessToken, data, userID) {
    //console.log("userID", userID);
    try {
      // 1. Ajustar 'miniature' con el archivo
      data.miniature = data.file;
      delete data.file; // ya no necesitamos 'file' en el formData

      // 2. Construir el FormData
      const formData = new FormData();
      Object.keys(data).forEach((key) => formData.append(key, data[key]));

      // 3. Formar la URL con el userID
      // Si ENV.API_ROUTES.ASSISTANCE = "assistanteduca",
      // esto resultará en algo como: "/assistanteduca/123abc"
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCE}/${userID}`;

      // 4. Configurar los parámetros del fetch
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      // 5. Hacer la petición
      const response = await fetch(url, params);
      const result = await response.json();

      // 6. Manejar respuesta
      if (response.status !== 200) {
        throw result;
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAssistances(accessToken, page = 1, limit = 100) {
    try {
      const pageFilter = `page=${page}`;
      const limitFilter = `limit=${limit}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCES}?${pageFilter}&${limitFilter}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await apiFetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateAssistance(accessToken, id, data) {
    try {
      if (data.miniature) {
        data.miniature = data.file;
      }
      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCE}/${id}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAssistance(accessToken, id) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCE}/${id}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAssistance(id) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCE}/${id}`;
      const response = await apiFetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  //creación de una funcion que obtenga miniature que es una imagen jpeg o png del assistance mediante el assistanceId
  async getMiniature(assistanceId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ASSISTANCE}/image/${assistanceId}`;
      //console.log("getMiniature -> url", url);
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      //console.log("getMiniature -> result", result);

      return result.imagePath; // Asegúrate de devolver el campo correcto
    } catch (error) {
      console.error("Error in getMiniature:", error);
      throw error;
    }
  }
}
